import { Group } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";
import { Link } from "wouter";

import MainColumn from "../../components/common/MainColumn";

import StoreLogoComponent from "../../components/StoreLogoComponent";
import SearchField from "../../components/search/SearchField";

const MobileSearchBar = () => {
   return (
      <div className="w-full bg-headerFooterBackground">
         <MainColumn>
            <Group>
               <div className="flex items-center py-2">
                  <Link to="/">
                     <StoreLogoComponent placement="searchbarMobile" />
                  </Link>
               </div>
               <div className="flex-auto py-2">
                  <SearchField />
               </div>
            </Group>
         </MainColumn>
      </div>
   );
};

export default observer(MobileSearchBar);
